import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74575b77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-background w-screen h-screen" }
const _hoisted_2 = { class: "flex flex-col justify-between" }
const _hoisted_3 = {
  class: "pageHeader flex justify-between",
  "data-cy": "damage-title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner-m" }, null, -1))
const _hoisted_5 = { class: "content w-100" }
const _hoisted_6 = { class: "title-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-4xl midHeader" }, " Allgemein ", -1))
const _hoisted_8 = { class: "mt-1 flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Datum der Meldung:", -1))
const _hoisted_10 = {
  class: "mt-0 w-60",
  "data-cy": "pdf-report-date"
}
const _hoisted_11 = { class: "mt-1 flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Beschreibung der Fehlermeldung:", -1))
const _hoisted_13 = {
  class: "mt-0 w-80 textBlock",
  "data-cy": "pdf-report-description"
}
const _hoisted_14 = { class: "mt-1 flex" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Priorität:", -1))
const _hoisted_16 = {
  class: "mt-0 w-80",
  "data-cy": "pdf-report-priority"
}
const _hoisted_17 = { class: "title-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-4xl midHeader" }, " Schaden - Info ", -1))
const _hoisted_20 = { class: "mt-1 flex" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Schwere des Schadens:", -1))
const _hoisted_22 = {
  class: "mt-0 w-80",
  "data-cy": "pdf-damage-severity"
}
const _hoisted_23 = {
  key: 0,
  class: "mt-3 flex"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-20" }, "Fotos:", -1))
const _hoisted_25 = {
  class: "mt-0",
  "data-cy": "pdf-picture-action"
}
const _hoisted_26 = {
  key: 1,
  class: "mt-1 flex",
  "data-cy": "pdf-picture-action"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-35" }, "Fotos:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-0 w-80" }, " Keine Fotos ", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "mt-1 flex section" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Schaden behoben:", -1))
const _hoisted_32 = {
  key: 0,
  class: "mt-0",
  "data-cy": "pdf-damage-repaired"
}
const _hoisted_33 = {
  key: 1,
  class: "mt-0",
  "data-cy": "pdf-damage-repaired"
}
const _hoisted_34 = { class: "title-container" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "trenner" }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-4xl midHeader" }, " Maßnahme - Info ", -1))
const _hoisted_37 = {
  key: 0,
  class: "section"
}
const _hoisted_38 = { class: "mt-1 flex" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Reparaturdatum:", -1))
const _hoisted_40 = {
  class: "mt-0 w-40",
  "data-cy": "pdf-repair-date"
}
const _hoisted_41 = { class: "mt-1 flex" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Beschreibung Maßnahme:", -1))
const _hoisted_43 = {
  class: "mt-0 w-80 textBlock",
  "data-cy": "pdf-description-action"
}
const _hoisted_44 = {
  key: 0,
  class: "mt-3 flex"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-20" }, "Fotos:", -1))
const _hoisted_46 = {
  class: "mt-0",
  "data-cy": "pdf-picture-action"
}
const _hoisted_47 = {
  key: 1,
  class: "mt-1 flex",
  "data-cy": "pdf-picture-action"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-35" }, "Fotos:", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-0 w-80" }, " Keine Fotos ", -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { class: "mt-1 flex" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Dauer:", -1))
const _hoisted_53 = {
  class: "mt-0",
  "data-cy": "pdf-repair-duration"
}
const _hoisted_54 = { class: "mt-1 flex" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Netzeinschaltung möglich:", -1))
const _hoisted_56 = {
  key: 0,
  class: "mt-0",
  "data-cy": "pdf-switch-on"
}
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  key: 1,
  class: "section"
}
const _hoisted_59 = { class: "mt-1 flex" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Bestehender Schaden", -1))
const _hoisted_61 = {
  class: "mt-0 w-80 textBlock",
  "data-cy": "pdf-existing-damage"
}
const _hoisted_62 = { class: "mt-1 flex" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-60" }, "Notwendige Maßnahme:", -1))
const _hoisted_64 = {
  class: "mt-0 w-80 textBlock",
  "data-cy": "pdf-necessary-action"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_PdfImageRow = _resolveComponent("PdfImageRow")!
  const _component_page_bottom = _resolveComponent("page-bottom")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createBlock(_component_pdf_a4_page, {
    "no-margin": "",
    "pdf-key": _ctx.lang
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_page_header, {
          ba: _ctx.ba,
          immobilie: _ctx.immobilie,
          Title: 'Meldungen'
        }, null, 8, ["ba", "immobilie"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "Schaden - " + _toDisplayString(_ctx.meldung.frages?.[1].eingabeText || 'Unbekannt'), 1),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.moment(_ctx.meldung.frages?.[0].eingabeText).isValid() ? _ctx.moment(_ctx.meldung.frages?.[0].eingabeText).format("DD.MM.YYYY") : '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.meldung.frages?.[2].eingabeText), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.meldung.frages?.[3].eingabeText), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.meldung.frages?.[4].eingabeAuswahlWert), 1)
              ]),
              (_ctx.meldung?.frages?.[5].eingabeMedien?.[0] != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_PdfImageRow, {
                        imageObjects: _ctx.getImageObjects(_ctx.meldung, 5)
                      }, null, 8, ["imageObjects"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29)),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                (_ctx.meldung.frages?.[6].eingabeBoolean == true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, " Ja "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_33, " Nein "))
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _hoisted_36,
              (_ctx.meldung.frages?.[6].eingabeBoolean == true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.moment(_ctx.meldung.frages?.[9]?.eingabeText, "YYYY-MM-DD", true).isValid() ? _ctx.moment(_ctx.meldung.frages?.[9].eingabeText).format("DD.MM.YYYY") : '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.meldung.frages?.[10].eingabeText), 1)
                    ]),
                    (_ctx.meldung?.frages?.[11].eingabeMedien?.[0] != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_PdfImageRow, {
                              imageObjects: _ctx.getImageObjects(_ctx.meldung, 11)
                            }, null, 8, ["imageObjects"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_50)),
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.meldung.frages?.[12].eingabeText + "h"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      (_ctx.meldung.frages?.[13].eingabeBoolean == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, " Ja "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_57, " Nein "))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.meldung.frages?.[7].eingabeText), 1)
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _hoisted_63,
                      _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.meldung.frages?.[8].eingabeText), 1)
                    ])
                  ]))
            ])
          ])
        ]),
        _createVNode(_component_page_bottom)
      ])
    ]),
    _: 1
  }, 8, ["pdf-key"]))
}